/**
 * ページトップボタンの表示制御
 * IntersectionObserver APIを使用して、特定のセクションがビューポートに入っているかを監視し、
 * ページトップボタンの表示を制御します。
 */

const initializePageTop = () => {
  const pageTop = document.getElementById("js-page-top");

  if (!pageTop) return;

  const mvSection = document.getElementById("js-top-mv");

  // メインビジュアルセクションが存在しない場合はページトップボタンを常に表示
  if (!mvSection) {
    pageTop.classList.add("is-show");
    return;
  }

  // メインビジュアルとフッターの可視状態を管理するフラグ
  let isMvVisible = true;

  // ページトップボタンの表示状態を更新する関数
  const updatePageTopVisibility = () => {
    // メインビジュアルとフッターが両方ともビューポートに入っていない場合にボタンを表示
    if (!isMvVisible) {
      pageTop.classList.add("is-show");
    } else {
      pageTop.classList.remove("is-show");
    }
  };

  // メインビジュアルセクションのIntersectionObserverのオプション
  const mvObserverOptions = {
    threshold: 0.8,
  };

  // メインビジュアルセクションの可視状態を監視するコールバック関数
  const mvObserverCallback = ([entry]) => {
    isMvVisible = entry.isIntersecting; // ビューポートに入っているかを判定
    updatePageTopVisibility(); // ボタンの表示状態を更新
  };

  // メインビジュアルセクション用のIntersectionObserverを作成
  const mvObserver = new IntersectionObserver(
    mvObserverCallback,
    mvObserverOptions
  );

  mvObserver.observe(mvSection);
};

initializePageTop();
